// Share a saved item: the phone's share sheet when there is one, else copy
// the link (or the text, for a note). Call it inside the tap that asked for
// it: navigator.share needs that user activation.

import { toast } from 'sonner';
import type { LibraryCard } from './libraryCard';

function linkOf(card: LibraryCard): string | null {
  if (card.url) return card.url;
  const c = (card.item.content ?? {}) as Record<string, unknown>;
  return card.item.item_type === 'file' && typeof c.url === 'string' && c.url ? c.url : null;
}

export async function shareCard(card: LibraryCard): Promise<void> {
  const url = linkOf(card);
  const text = card.text || card.title;
  try {
    if (typeof navigator.share === 'function') {
      await navigator.share(url ? { title: card.title || undefined, url } : { text });
      return;
    }
  } catch (err) {
    if ((err as DOMException)?.name === 'AbortError') return;
  }
  try {
    await navigator.clipboard.writeText(url ?? text);
    toast(url ? 'Copied the link' : 'Copied the text');
  } catch {
    toast.error('Could not share this');
  }
}
